import * as React from 'react';
import { Link } from 'react-router-dom';
import './BoxItemsMobile.scss';
const BoxItemsMobile = (props) => {
  const { data } = props;
  return (
    <div className='box-items-mobile' key={data?.id}>
      {' '}
      <Link to={data.link}>
        <div
          className='card-info'
          style={{ background: data?.backgroundColor }}
        >
          <div>
            <div className='title-card'>{data.title}</div>
            <div className='description-text'>{data.description}</div>
          </div>
          <div
            className='icon-card'
            style={{ opacity: data?.id === 2 ? 1 : 0.2 }}
          >
            {data.icon}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BoxItemsMobile;
